const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
});

export const paystackService = {
  async listBanks() {
    const response = await fetch(`${API_URL}/api/paystack/connect/banks`, {
      headers: authHeaders(),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message);
    return result.banks;
  },

  async resolveAccount(accountNumber, bankCode) {
    const response = await fetch(`${API_URL}/api/paystack/connect/resolve`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify({ accountNumber, bankCode }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message);
    return result.accountName;
  },

  async createSubaccount({ businessName, bankCode, accountNumber }) {
    const response = await fetch(`${API_URL}/api/paystack/connect/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify({ businessName, bankCode, accountNumber }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message);
    return result;
  },

  async getAccountStatus() {
    const response = await fetch(`${API_URL}/api/paystack/connect/status`, {
      headers: authHeaders(),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message);
    return result;
  },

  /**
   * Create payment link for an LBA — mirrors stripeService.createPaymentLink,
   * hitting the matching POST /api/paystack/payment-link/:lbaId route.
   */
  async createPaymentLink(lbaId) {
    try {
      const response = await fetch(
        `${API_URL}/api/paystack/payment-link/${lbaId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", ...authHeaders() },
        }
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error creating Paystack payment link:", error);
      throw error;
    }
  },
  async disconnectAccount() {
    const response = await fetch(`${API_URL}/api/paystack/connect/disconnect`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message);
    return result;
  },
  
};